namespace Matrix.Scheduling {
    export namespace CalendarService {
        export const baseUrl = 'Scheduling/Calendar';

        export declare function Create(request: Serenity.SaveRequest<CalendarRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CalendarRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CalendarRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CalendarRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetEntries(request: CalendarGetEntriesRequest, onSuccess?: (response: Serenity.ListResponse<CalendarEntryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Scheduling/Calendar/Create",
            Update = "Scheduling/Calendar/Update",
            Delete = "Scheduling/Calendar/Delete",
            Retrieve = "Scheduling/Calendar/Retrieve",
            List = "Scheduling/Calendar/List",
            GetEntries = "Scheduling/Calendar/GetEntries"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetEntries'
        ].forEach(x => {
            (<any>CalendarService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
